import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Avatar,
  Box,
} from "@mui/material";
import { Icon } from "@iconify/react";
import moment from "moment";
import { convertCurrencyToSignNew } from "../../utils/Constant";
import { useIds } from "../../hook/AdminContext";

function TransactionsTable({ transactions }) {
  const { userInfo } = useIds();
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "success":
        return { color: "success", label: "Paid", fontColor: "white" };
      case "pending":
        return { color: "warning", label: "Pending", fontColor: "white" };
      case "failed":
        return { color: "error", label: "Failed", fontColor: "white" };
      default:
        return { color: "default", label: status, fontColor: "gray" };
    }
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 3,
        boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
        overflow: "hidden",
      }}
    >
      <Table>
        {/* Table Head */}
        <TableHead sx={{ background: "#fafafa" }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, fontSize: 15 }}></TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: 15 }}>Client</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: 15 }}>
              Charged Amount
            </TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: 15 }}>Date</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: 15 }}>Status</TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {transactions.length > 0 ? (
            transactions.map((txn, index) => {
              const { color, label, fontColor } = getStatusColor(
                txn.transaction_status
              );
              return (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                    transition: "background 0.2s",
                  }}
                >
                  {/* Charged Amount */}
                  <TableCell>{index + 1}</TableCell>
                  {/* Client Info */}
                  <TableCell>
                    <Box>
                      <Box sx={{ fontWeight: 600 }}>
                        {userInfo.company_name || "-"}
                      </Box>
                      <Box sx={{ fontSize: 13, color: "#777" }}>
                        {userInfo.email}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    {convertCurrencyToSignNew(
                      txn?.plan_info?.plan_currency || ""
                    )}
                    {txn.paid_amount.toFixed(2)}
                  </TableCell>

                  {/* Date */}
                  <TableCell sx={{ color: "#555" }}>
                    {moment(txn.createdAt).format("MMM DD, YYYY")}
                  </TableCell>

                  {/* Status */}
                  <TableCell>
                    <Chip
                      label={label}
                      color={color}
                      variant="soft"
                      sx={{
                        fontWeight: 500,
                        textTransform: "capitalize",
                        "& .MuiChip-label": {
                          color: fontColor,
                        },
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={5}>
                <Box
                  sx={{
                    textAlign: "center",
                    py: 6,
                    color: "#777",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Icon
                    icon="mdi:file-search-outline"
                    width={42}
                    height={42}
                    color="#ccc"
                  />
                  <Box sx={{ fontSize: 16, fontWeight: 500, mt: 1 }}>
                    No transactions found
                  </Box>
                  <Box sx={{ fontSize: 13, color: "#999", mt: 0.5 }}>
                    Your recent transactions will appear here.
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TransactionsTable;
